<template>
  <div class="user_info_container">
    <div class="wrap displayFlex">
      <div class="base">
        <div class="base_wrap displayFlex">
          <el-avatar class="avatar" shape="square" :size="90" :src="userInfo.memberHeadImg || 'https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png'"></el-avatar>
          <div class="infos">
            <div class="text"><span>{{userInfo.memberName}}</span>
              <el-tag class="text_tag marlr" type="success">{{userInfo.memberAge || '0'}}岁</el-tag>
              <el-tag class="text_tag" type="success">{{userInfo.memberSex == '1' ? '男': userInfo.memberSex == '2' ? '女' : '未知'}}</el-tag>
            </div>
            <div class="text"><span>{{userInfo.photoNumber}}</span><span class="marlr_max">来源：{{userInfo.enterpriseName}}</span> <span>创建时间：{{userInfo.createTime}}</span></div>
            <div class="text"><span>健康管理师：{{userInfo.healthManagePersonName}}</span></div>
          </div>
        </div>
      </div>
      <div class="line"></div>
      <div class="base">
        <p class="title">会员标签</p>
        <div class="labels" v-if="userInfo.memberLabelNames">
          <span class="label_title">慢病情况：</span>
          <el-tag class="label_tag" effect="dark" v-for="(item, index) in userInfo.memberLabelNames" :key="index">
            {{item}}
          </el-tag>
        </div>
        <div class="labels" v-else>
          <span class="label_title">暂无相关标签</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    memberId: Number, // 会员ID
  },
  data() {
    return {
      loginData: JSON.parse(localStorage.getItem('loginData')) || {}, // 登录药企基本信息
      userInfo: {}
    }
  },
  watch: {

  },
  created() {
    this.getMemberInfo();
  },
  methods: {
    getMemberInfo() { // 获取会员信息
      this.$https.get('system/memberArchives/getArchivesInfoByMemberId', { memberId: this.memberId, enterpriseId: this.loginData.enterpriseId }).then(res => {
        this.userInfo = res.data || [];
        this.userInfo.memberLabelNames = this.userInfo.memberLabelNames && this.userInfo.memberLabelNames.split('、');
        console.log('获取会员详情========>', res);
      }).catch(res => {

      })
    },
  }
}
</script>

<style lang="less" scoped>
.displayFlex {
    display: box; /* OLD - Android 4.4- */
    display: -webkit-box; /* OLD - iOS 6-, Safari 3.1-6 */
    display: -moz-box; /* OLD - Firefox 19- (buggy but mostly works) */
    display: -ms-flexbox; /* TWEENER - IE 10 */
    display: -webkit-flex; /* NEW - Chrome */
    display: flex; /* NEW, Spec - Opera 12.1, Firefox 20+ */
}
.flex1 {
    -webkit-box-flex: 1; /* OLD - iOS 6-, Safari 3.1-6 */
    -moz-box-flex: 1; /* OLD - Firefox 19- */
    width: 20%; /* For old syntax, otherwise collapses. */
    -webkit-flex: 1; /* Chrome */
    -ms-flex: 1; /* IE 10 */
    flex: 1; /* NEW, Spec - Opera 12.1, Firefox 20+ */
}
.wrap {
    color: #696868;
    .base {
        .title {
            font-weight: bold;
            font-size: 15px;
        }
        .labels {
            margin-top: 15px;
            color: red;
            font-size: 13px;
            .label_tag {
                margin-right: 15px;
            }
        }
        .base_wrap {
            .avatar {
                margin-right: 20px;
            }
            .infos {
                .text {
                    font-size: 15px;
                    margin-bottom: 10px;
                }
                .marlr {
                    margin: 0 20px;
                }
                .marlr_max {
                    margin: 0 50px;
                }
            }
        }
    }
    .line {
        margin: 0 20px;
        width: 2px;
        background: #ebeef5;
    }
}
</style>
